import gql from 'graphql-tag'

export const updateBanner = ({ bannerId, bannerData, bannerRoles }) => {
	return {
		mutation: gql`
			mutation (
				$banner_id: bigint!
				$object: banners_set_input!
				$roles: [banners_roles_insert_input!]!
			) {
				update_banners_by_pk(pk_columns: { id: $banner_id }, _set: $object) {
					id
				}
				delete_banners_roles(where: { banner_id: { _eq: $banner_id } }) {
					affected_rows
				}
				insert_banners_roles(objects: $roles) {
					affected_rows
				}
			}
		`,
		variables: {
			object: bannerData,
			banner_id: bannerId,
			roles: bannerRoles.map(rol => ({
				banner_id: bannerId,
				rol_id: rol.id
			}))
		}
	}
}
